/* AppTileBadge.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["ribbonGradient"],
  _excluded4 = ["as", "style"],
  _excluded5 = ["textColor", "badgeBackground"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _25 = "._154iuvez{top:-.0625rem}";
const _24 = "._1xi21ejb{right:var(--ds-space-300,24px)}";
const _23 = "._2rko1q1w{border-radius:var(--_gr565q)}";
const _22 = "._bfhk1lok{background-color:var(--_1e7ijj1)}";
const _21 = "._1wyb1yny{font-size:.688rem}";
const _20 = "._k48pni7l{font-weight:600}";
const _19 = "._syazijt0{color:var(--_1qrlcdp)}";
const _18 = "._1yt4u49m{padding:var(--ds-space-025,2px) var(--ds-space-050,4px)}";
const _17 = "._1oj4y1ik:after{-webkit-clip-path:polygon(100% 0,0 100%,100% 100%);clip-path:polygon(100% 0,0 100%,100% 100%)}";
const _16 = "._1qdg1osq:after{height:100%}";
const _15 = "._z0ai1osq:after{width:100%}";
const _14 = "._18postnw:after{position:absolute}";
const _13 = "._aetrb3bt:after{content:\"\"}";
const _12 = "._16r214oi:after{background:var(--_utelyw)}";
const _11 = "._4t3i1b66{height:var(--ds-space-050,4px)}";
const _10 = "._1bsbh72c{width:.4375rem}";
const _9 = "._1ltv10ao{left:-.4375rem}";
const _8 = "._154iidpf{top:0}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { B300, B500, G300, G500, P300, P500 } from '@atlaskit/theme/colors';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { BadgeVariant } from '@atlassian/mpac-types';
import { TEST_IDS } from '../../primitives/testIds';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _7 = "._ect41kw7{font-family:inherit}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._16qs1j92{box-shadow:0 .0625rem var(--ds-space-050,4px) 0 rgba(0,0,0,.25)}";
const _4 = "._154i19tf{top:-.3125rem}";
const _3 = "._1xi2pxbi{right:var(--ds-space-200,1pc)}";
const _2 = "._kqswstnw{position:absolute}";
const _ = "._2rkoqdnr{border-radius:0 .0625rem var(--ds-space-050,4px) var(--ds-space-050,4px)}";
const AppTileBadgeContainer = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_2rkoqdnr _kqswstnw _1xi2pxbi _154i19tf _16qs1j92 _1e0c1txw _ect41kw7", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppTileBadgeContainer.displayName = 'AppTileBadgeContainer';
}
const AppTileBadgeContainerStyle = null;
const Ribbon = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  const {
      ribbonGradient
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_utelyw": ix(__cmplp.ribbonGradient)
      }),
      ref: __cmplr,
      className: ax(["_kqswstnw _154iidpf _1ltv10ao _1bsbh72c _4t3i1b66 _16r214oi _aetrb3bt _18postnw _z0ai1osq _1qdg1osq _1oj4y1ik", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Ribbon.displayName = 'Ribbon';
}
const Badge = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  const {
      textColor,
      badgeBackground
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded5);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _18, _19, _20, _21, _22]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmpldp), {}, {
      style: _objectSpread(_objectSpread({}, __cmpls), {}, {
        "--_1qrlcdp": ix(__cmplp.textColor),
        "--_1e7ijj1": ix(__cmplp.badgeBackground)
      }),
      ref: __cmplr,
      className: ax(["_2rkoqdnr _1yt4u49m _syazijt0 _k48pni7l _1wyb1yny _bfhk1lok", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Badge.displayName = 'Badge';
}
const badge = {
  [BadgeVariant.SPOTLIGHT]: {
    text: 'SPOTLIGHT',
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    badgeBackground: "var(--ds-background-discovery-bold, #6E5DC6)",
    ribbonGradient: "linear-gradient(to left bottom, ".concat(P500, ", ").concat(P300, ")")
  },
  [BadgeVariant.BESTSELLER]: {
    text: 'BESTSELLER',
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    badgeBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
    ribbonGradient: "linear-gradient(to left bottom, ".concat(G500, ", ").concat(G300, ")")
  },
  [BadgeVariant.RISINGSTAR]: {
    text: 'RISING STAR',
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    badgeBackground: "var(--ds-background-information-bold, #0C66E4)",
    ribbonGradient: "linear-gradient(to left bottom, ".concat(B500, ", ").concat(B300, ")")
  },
  [BadgeVariant.NEW]: {
    text: 'NEW',
    textColor: "var(--ds-text-discovery, #5E4DB2)",
    badgeBackground: "var(--ds-background-discovery, #F3F0FF)",
    ribbonGradient: "linear-gradient(to left bottom, ".concat(P500, ", ").concat(P300, ")")
  }
};
const badgeWC = {
  [BadgeVariant.SPOTLIGHT]: {
    textWC: 'SPOTLIGHT',
    textColorWC: "var(--ds-text-inverse, #FFFFFF)",
    badgeBackgroundWC: "var(--ds-background-accent-purple-bolder, #6E5DC6)"
  },
  [BadgeVariant.BESTSELLER]: {
    textWC: 'BESTSELLER',
    textColorWC: "var(--ds-text-inverse, #FFFFFF)",
    badgeBackgroundWC: "var(--ds-background-accent-lime-bolder, #5B7F24)"
  },
  [BadgeVariant.RISINGSTAR]: {
    textWC: 'RISING STAR',
    textColorWC: "var(--ds-text-inverse, #FFFFFF)",
    badgeBackgroundWC: "var(--ds-background-accent-blue-bolder, #0C66E4)"
  },
  [BadgeVariant.NEW]: {
    textWC: 'NEW',
    textColorWC: "var(--ds-text-accent-purple, #5E4DB2)",
    badgeBackgroundWC: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
  }
};
export function AppTileBadge(_ref4) {
  let {
    variant
  } = _ref4;
  const {
    text,
    textColor,
    badgeBackground,
    ribbonGradient
  } = badge[variant];
  const {
    textWC,
    textColorWC,
    badgeBackgroundWC
  } = badgeWC[variant];
  const {
    enableMpacWebCoherence
  } = useStatsig();
  if (enableMpacWebCoherence()) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_23, _2, _24, _25, _6, _7]
      }), /*#__PURE__*/_jsx("div", {
        "data-testid": TEST_IDS.TILE_BADGE,
        className: ax(["_2rko1q1w _kqswstnw _1xi21ejb _154iuvez _1e0c1txw _ect41kw7"]),
        style: {
          "--_gr565q": ix("0rem 0.0625rem ".concat("var(--ds-space-050, 4px)", " ", "var(--ds-space-050, 4px)"))
        },
        children: /*#__PURE__*/_jsx(Badge, {
          badgeBackground: badgeBackgroundWC,
          textColor: textColorWC,
          children: textWC
        })
      })]
    });
  }
  return /*#__PURE__*/_jsxs(AppTileBadgeContainer, {
    "data-testid": TEST_IDS.TILE_BADGE,
    children: [/*#__PURE__*/_jsx(Ribbon, {
      ribbonGradient: ribbonGradient
    }), /*#__PURE__*/_jsx(Badge, {
      badgeBackground: badgeBackground,
      textColor: textColor,
      children: text
    })]
  });
}